import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
const paymentData = [
  {
    id: 1,
    transactionId: 'TXN1001',
    customer: 'Rohit Sharma',
    amount: '₹ 2,500',
    gateway: 'Razorpay',
    mode: 'UPI',
    status: 'Success',
    date: '2025-01-10',
  },
  {
    id: 2,
    transactionId: 'TXN1002',
    customer: 'Deepak Verma',
    amount: '₹ 1,200',
    gateway: 'Stripe',
    mode: 'Card',
    status: 'Pending',
    date: '2025-01-11',
  },
  {
    id: 3,
    transactionId: 'TXN1003',
    customer: 'Anjali Mehta',
    amount: '₹ 4,000',
    gateway: 'PayPal',
    mode: 'NetBanking',
    status: 'Failed',
    date: '2025-01-12',
  },
  {
    id: 4,
    transactionId: 'TXN1004',
    customer: 'Vikas Singh',
    amount: '₹ 800',
    gateway: 'Cashfree',
    mode: 'Wallet',
    status: 'Success',
    date: '2025-01-13',
  },
  {
    id: 5,
    transactionId: 'TXN1005',
    customer: 'Priya Kapoor',
    amount: '₹ 3,300',
    gateway: 'PayU',
    mode: 'UPI',
    status: 'Refunded',
    date: '2025-01-14',
  },
];

function PaymentList() {
  const [search, setSearch] = useState('');

  const filteredData = paymentData.filter(
    (item) =>
      item.transactionId.toLowerCase().includes(search.toLowerCase()) ||
      item.customer.toLowerCase().includes(search.toLowerCase()) ||
      item.gateway.toLowerCase().includes(search.toLowerCase())
  );

  const getStatusClass = (status) => {
    switch (status) {
      case 'Success':
        return 'badge bg-success';
      case 'Pending':
        return 'badge bg-warning text-dark';
      case 'Failed':
        return 'badge bg-danger';
      case 'Refunded':
        return 'badge bg-info text-dark';
      default:
        return 'badge bg-secondary';
    }
  };

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Payment List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Payment List</span>
          </nav>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">
            <div className="container">
              <div className="row mb-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control custumform"
                    placeholder="Search by Transaction ID, Customer or Gateway..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

            <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
                  <thead className="">
                    <tr>
                      <th>#</th>
                      <th>Transaction ID</th>
                      <th>Vendor Name</th>
                      <th>Amount</th>
                      <th>Gateway</th>
                      <th>Mode</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.transactionId}</td>
                          <td>{item.customer}</td>
                          <td>{item.amount}</td>
                          <td>{item.gateway}</td>
                          <td>{item.mode}</td>
                          <td>
                            <span className={getStatusClass(item.status)}>
                              {item.status}
                            </span>
                          </td>
                          <td>{item.date}</td>
                            <td>
                                                <div className="d-flex align-items-center justify-content-center gap-1">
                                                  <button
                                                    className="st-action-btn st-delete-btn"
                                                    // onClick={() =>
                                                    //   dispatch(
                                                    //     openModal({
                                                    //       type: "view-role",
                                                    //       title: "View Role",
                                                    //       data: item,
                                                    //     })
                                                    //   )
                                                    // }
                                                  >
                                                    <FaEye />
                                                  </button>
                        
                                                  <button
                                                    className="st-action-btn st-view-btn"
                                                    // onClick={() =>
                                                    //   dispatch(
                                                    //     openModal({
                                                    //       type: "edit-role",
                                                    //       title: "Edit Role",
                                                    //       data: item,
                                                    //       onSuccess: fetchRoles,
                                                    //     })
                                                    //   )
                                                    // }
                                                  >
                                                    <FaEdit />
                                                  </button>
                        
                        
                                                  <button
                                                    className="st-action-btn st-edit-btn"
                                                    // onClick={() =>
                                                    //   dispatch(
                                                    //     openModal({
                                                    //       type: "delete-role",
                                                    //       title: "Delete Role",
                                                    //       data: {
                                                    //         _id: item.id,
                                                    //         name: item.name,
                                                    //         deleteFunction: DeleteRole,
                                                    //         refreshData: fetchRoles,
                                                    //       },
                                                    //     })
                                                    //   )
                                                    // }
                                                  >
                                                    <FaTrash />
                                                  </button>
                                                </div>
                                              </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No payment records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentList;